import { asLabel } from '@shure/shared/models';

export enum UserReactionEnum {
	NotImportant = 'NOT_IMPORTANT',
	NiceToHave = 'NICE_TO_HAVE',
	Important = 'IMPORTANT',
	Critical = 'CRITICAL'
}

export const userReactionEnumLabels = [
	{ label: asLabel('cloud.shared.feature-request.not-important'), key: UserReactionEnum.NotImportant },
	{ label: asLabel('cloud.shared.feature-request.nice-to-have'), key: UserReactionEnum.NiceToHave },
	{ label: asLabel('cloud.shared.feature-request.important'), key: UserReactionEnum.Important },
	{ label: asLabel('cloud.shared.feature-request.critical'), key: UserReactionEnum.Critical }
];

export interface FeatureRequest {
	featureId: string;
	title: string;
	description: string;
	createdAt: string;
	voteCount: number;
	userReaction?: string;
	userFeedback?: string | null;
}

export interface SubmitFeatureRequest {
	title: string;
	description: string;
}
